module.exports = __webpack_public_path__ + "static/img/img_red.e68a19d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_red.png
// module id = OPd8
// module chunks = 1